import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import api from '@/services/api';
import { API_URL } from '@/services/config';

export default function PaymentSuccessPage() {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('order_id');
  const baseUrl = window.location.origin;

  const [invoiceId, setInvoiceId] = useState<number | null>(null);
  const [invoiceLoading, setInvoiceLoading] = useState(!!orderId);

  useEffect(() => {
    if (!orderId) return;

    let cancelled = false;
    let attempts = 0;
    const maxAttempts = 12;
    let timer: number | undefined;

    const checkInvoice = async () => {
      if (cancelled) return;

      try {
        const res = await api.get(`/track-order/${orderId}`);
        const trx = res.data?.trx_number;
        if (!cancelled && trx && /^\d+$/.test(String(trx))) {
          setInvoiceId(Number(trx));
          setInvoiceLoading(false);
          if (timer) window.clearInterval(timer);
          return;
        }
      } catch {
        // ignore transient errors while the invoice is being generated
      }

      attempts += 1;
      if (attempts >= maxAttempts) {
        if (!cancelled) setInvoiceLoading(false);
        if (timer) window.clearInterval(timer);
      }
    };

    timer = window.setInterval(checkInvoice, 2500);
    checkInvoice();

    return () => {
      cancelled = true;
      if (timer) window.clearInterval(timer);
    };
  }, [orderId]);

  return (
    <main className="min-h-screen flex items-center justify-center bg-cream-50 py-16">
      <div className="text-center max-w-md mx-auto px-4">
        <div className="w-20 h-20 rounded-full bg-green-50 flex items-center justify-center mx-auto mb-6">
          <i className="ri-check-line text-3xl text-green-600" />
        </div>
        <h1 className="text-2xl font-bold text-charcoal-900 mb-3">تم الدفع بنجاح!</h1>
        {orderId && <p className="text-charcoal-500 mb-1 text-sm">رقم الطلب: <span className="font-mono font-bold">{orderId}</span></p>}
        <p className="text-charcoal-600 mb-6 text-sm">شكراً لتسوقك معنا. تم تأكيد طلبك وسيتم تجهيزه قريباً.</p>

        {invoiceId ? (
          <a
            href={`${API_URL}/invoices/${invoiceId}/pdf`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-charcoal-900 text-white px-6 py-3 rounded-xl text-sm font-medium hover:bg-charcoal-800 transition-colors mb-6"
          >
            <i className="ri-file-download-line" />
            تحميل الفاتورة
          </a>
        ) : invoiceLoading ? (
          <p className="text-charcoal-400 text-xs mb-6">جاري تجهيز الفاتورة...</p>
        ) : null}

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <a href={`${baseUrl}/track-order`} className="btn-primary text-center text-sm">تتبع الطلب</a>
          <a href={`${baseUrl}/shop`} className="btn-outline text-center text-sm">مواصلة التسوق</a>
        </div>
      </div>
    </main>
  );
}
